<h3 [innerHTML]="buyBookText.heading"></h3>
<div [innerHTML]="buyBookText.mainText" class="id37-text2 text-light"></div>
